import React from 'react'
import classNames from 'classnames'
import styles from './CurrencyRadioGroup.module.css'

interface CurrencyOption {
  value: string
  label: string
  className?: string
}

interface CurrencyRadioGroupProps {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  name?: string
  options?: CurrencyOption[]
  wrapperClassName?: string
  labelClassName?: string
  itemClassName?: string
  showDefaultMargin?: boolean
  alignCenter?: boolean
}

const DEFAULT_OPTIONS: CurrencyOption[] = [
  { value: 'BYN', label: 'BYN', className: 'mr-1' },
  { value: 'EUR', label: 'EUR', className: 'mr-1' },
  { value: 'RUB', label: 'RUB', className: 'mr-1' },
  { value: 'USD', label: 'USD' },
]

const CurrencyRadioGroup: React.FC<CurrencyRadioGroupProps> = ({
  value,
  onChange,
  name = 'currency',
  options = DEFAULT_OPTIONS,
  wrapperClassName,
  labelClassName,
  itemClassName,
  showDefaultMargin = true,
  alignCenter = false,
}) => {
  return (
    <div
      className={classNames(
        styles.radioTabs,
        'd-flex',
        alignCenter ? 'justify-content-center' : 'justify-content-start',
        showDefaultMargin && 'mt-1',
        wrapperClassName
      )}
      style={{ textAlign: 'left', flexWrap: 'nowrap' }}
    >
      {options.map((option) => (
        <div
          key={option.value}
          className={classNames(
            showDefaultMargin && 'mt-1',
            option.className,
            itemClassName
          )}
        >
          <input
            name={name}
            id={`${name}_${option.value}`}
            type="radio"
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
          />
          <label
            className={classNames(
              labelClassName || styles.labelCurrency,
              !labelClassName && 'ml-1 mr-0'
            )}
            htmlFor={`${name}_${option.value}`}
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  )
}

export default CurrencyRadioGroup
